import React, { useEffect, useState, useRef } from "react";
import "./../styles/theme.css";

const SettingsMenu = ({ fetchNewsUsage }) => {
  const [usage, setUsage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);
  const didInit = useRef(false);

  const loadUsage = async ({ silent = false } = {}) => {
    try {
      if (!silent) setLoading(true);
      setErr(null);
      const u = await fetchNewsUsage();
      setUsage(u);
    } catch (e) {
      console.error("Failed to load GNews usage:", e);
      setErr("Could not load usage");
    } finally {
      if (!silent) setLoading(false);
    }
  };

  useEffect(() => {
    if (!didInit.current) {
      didInit.current = true;
      loadUsage({ silent: false });
    }
    const intervalId = setInterval(() => loadUsage({ silent: true }), 60_000);
    const onFocus = () => loadUsage({ silent: true });
    window.addEventListener("focus", onFocus);
    return () => {
      clearInterval(intervalId);
      window.removeEventListener("focus", onFocus);
    };
  }, []);

  const fmt = (n) => (typeof n === "number" ? n.toLocaleString() : String(n ?? ""));

  return (
    <div className="settings-menu">
      {/* GNews API */}
      <div className="section">
        <div className="section-head"><span>GNEWS API</span></div>

        <div className="sentiment-desc">
          {loading && <div className="settings-value">Loading…</div>}
          {err && !loading && <div className="settings-error">{err}</div>}

          {usage && !loading && !err && (
            <div className="kv-grid">
              <div className="kv-label">Token limit</div>
              <div className="kv-value">{fmt(usage.limit)}</div>

              <div className="kv-label">Used today</div>
              <div className="kv-value">{fmt(usage.used)}</div>

              <div className="kv-label">Remaining</div>
              <div className="kv-value">{fmt(usage.remaining)}</div>

              <div className="kv-span kv-note">
                Resets {usage.resetDay} at {usage.resetTime}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* OpenAI API */}
      <div className="section">
        <div className="section-head"><span>OPENAI API</span></div>
        <div className="sentiment-desc"><span class="kv-note">in development</span></div>
      </div>
    </div>
  );
};

export default SettingsMenu;
